import React from "react"
import Link from "./link"
import { htmlDecode } from "../Utils"

const Accordion = ({
  key,
  heading=null,
  content=null,
  link=null,
  accordionPanels=null
}) => {
  return (
    <div className="three-block-icon-with-text-grid before-white">
      <div className="container">
        <div className="row ph1">
          <div className="col-12 d-flex">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-3 text-center pv8">
              {heading &&
                <h2 className="text-center ft10 mb1">{ htmlDecode(heading) }</h2>
              }
              {content &&
                <div className="mt0 mb2" dangerouslySetInnerHTML={{ __html: content }} />
              }
              {link &&
                <Link className="button mb2" rel={ `${link.addNoFollowToLink ? "nofollow" : ""} ${link.addSponsoredToLink ? "sponsored" : ""} ${link.addUgcToLink ? "ugc" : ""}` } target={ `${link.openLinkInNewTab ? "_blank" : "_self"}` } title={ link.title } href={ link.url }>{ link.text }</Link>
              }
              <div className="accordion-block mt4">
                {accordionPanels && accordionPanels.map((panel, index) => (
                  <div className="accordion" id={ `accordion-${index}` }>
                    <div className="card xbrdr xbr mb-5">
                      <div className="card-header xp xbg" id={ `heading-${index}` }>
                        <h5 className="mb-0">
                          <button className="btn btn-link btn-level-1 collapsed" type="button" data-toggle="collapse" data-target={ `#collapse-${index}` } aria-expanded="false" aria-controls={ `collapse-${index}` }>
                            {panel.panelTitle &&
                              <span className="dept-name">{ htmlDecode(panel.panelTitle) }</span>
                            }
                            <span className="btn-carat fas fa-angle-down"></span>
                          </button>
                        </h5>
                      </div>
                      <div id={ `collapse-${index}` } className="collapse" aria-labelledby={ `heading-${index}` } data-parent={ `#accordion-${index}` }>
                        {panel.panelContent &&
                          <div className="card-body text-left pt1" dangerouslySetInnerHTML={{ __html: panel.panelContent }} />
                        }
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Accordion
